define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/FormData",
	"csi/comm",
	"csi/reflection",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"Sourcing",
	"Apparel/ProductType",
	"Apparel/ProductAlternativeForm",
	"Sourcing/SupplierItemForm"
], function(declare,_,FormData,comm,reflection,New,ActionControllerMixin,xml,Sourcing,ProductType) {

	var PRODUCT_ALTERNATIVE_FORM = 0;
	var SUPPLIER_ITEM_FORM = 1;

	return declare([New, ActionControllerMixin], {
		/** @property {string} idForSupplierFactoryField - id of the SupplierFactory field  */
		idForSupplierFactoryField: null,

		/** @property {string} idForSupplierField - id of the Supplier field  */
		idForSupplierField: null,

		/** @property {boolean}  isFDDEnabled - indicate if FDD is enabled for this product  */
		isFDDEnabled: null,

		onWizardViewCreate: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view) {
			// summary: notify when view created for page
			if (wizard.getIndexOfPage(page) == 0) {
				wizard.connect(view, "onChangeField", function() {
				    wizard.set("disabled", false);
				});
			}
		},

		/** @override
		 * Set the isFDDEnabled to the viewParams for SupplierItemForm
		 */
		onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view, /*Object*/viewParams) {
			if (wizard.getIndexOfPage(page) == 1) {
				this.isFDDEnabled = ProductType.isFDDProduct(this.getParent());
				viewParams.isFDDEnabled = this.isFDDEnabled;
			}
		},

		disableNext: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if CreateQuote is not checked
			if (index == 0) {
				var	defView = page.viewTab.defView;
				return !defView.getFieldValue("CreateQuote");
			}

			return this.inherited(arguments);
		},

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if CreateQuote is checked
			if (index == 0) {
				var	defView = page.viewTab.defView;
				return defView.getFieldValue("CreateQuote");
			}

			return this.inherited(arguments);
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var	nPage = wizard.getIndexOfPage(nextPage);
			var	bRefresh, dfd, fd, view;
			var specURL = this._getSpecURL();

			// assign colorSizePairs to the form data when finishing wizard on second page
			if (bFinish) {
				if (this._fdQuote && currentPage.viewTab.getSelectedColorSizePairs)
					this._fdQuote.colorSizePairs = currentPage.viewTab.getSelectedColorSizePairs();
				return null;
			}

			switch (nPage) {
				case PRODUCT_ALTERNATIVE_FORM:	{
					fd = this.m_formData;
					break;
				}

				// SupplierItem form
				case SUPPLIER_ITEM_FORM: {
					fd = this._fdQuote || (this._fdQuote = new FormData(this));
					if (specURL != this._prevSpecURL) {
						this._prevSpecURL = specURL;
						bRefresh = true;
					}
					break;
				}
			}

			// set form data for next page in wizard and refresh view if necessary
			if (fd) {
				var params = null;
				if (nPage == SUPPLIER_ITEM_FORM) {
					var paForm = currentPage.getView(wizard);
					params = {
						paSpec: paForm.cacheView.getNode(specURL, true),
						themePA: paForm.cacheView.getNode(this._getThemePaURL(), true),
						nodeProduct: this.getParent()
					};
				}
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh, params);

				if (nPage == SUPPLIER_ITEM_FORM) {
					// set Product to the form
					nextPage.viewTab._resetProductData();
					nextPage.viewTab.setProduct(this.getParent());
				}
			}

			return dfd;
		},

		/**
		 * @override
		 * populate the properties from the Form
		 */
		onPostNextPage(wizard, currentPage) {
			if (wizard.getIndexOfPage(currentPage)===1) {
				const widget = currentPage.getView();
				const {FACTORY, SUPPLIER} = widget;
				this.idForSupplierFactoryField = FACTORY;
				this.idForSupplierField = SUPPLIER;
			}
		 },

		// override this
		_getSpecURL: function() {
			return null;
		},

		_getThemePaURL: function() {
			return null;
		},

		toWriter: function() {
			const call = this.inherited(arguments);
			const fd = this._fdQuote;
			const { isFDDEnabled, idForSupplierField ,idForSupplierFactoryField, m_urlParent, m_urlNode, m_formData, m_writer, } = this;

			if (!m_formData.getFieldValue("CreateQuote") || !fd) {
				return call;
			}

			// Create SupplierItem if CreateQuote option is true
			const fieldId =  isFDDEnabled ? idForSupplierFactoryField : idForSupplierField;
			const field = fd.getField(fieldId);
			const store = field ? field.m_control.get("store") : null;
			const sources = fd.getFieldValue(fieldId, true);

			 const creator = (source)=> {
				const quoteURL = comm.createUrl("SupplierItem");

				if (!quoteURL) {
					throw new Error('URLCREATE');
				} 

				m_writer.callMethod("Sourcing", "ProductSourcingCreateSupplierItem")
					.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, m_urlParent)
					.addParameter(xml.PROP_URL, xml.ATTR_REF, quoteURL)
					.addParameter("SrcURL", xml.ATTR_REF, source)
					.addParameter("TemplateURL", xml.ATTR_REF, fd.getFieldValue("SupplierItemTemplate", true));

				// Following line is necessary due to the call to formData.clearUsedFields from Sourcing.createSupplierItems
				fd.getFieldValue(fieldId, true);

				// add unclaimed form field values to the new quote
				this.toWriterFields(quoteURL, fd);

				m_writer.changeNode(xml.getUrlPath(quoteURL, reflection.PATH_CURRENT_REVISION))
					.changeAttribute("QuoteProductAlternative", xml.ATTR_REF, m_urlNode)
					.changeAttributeFlag("QuoteProductAlternative", xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);

				return quoteURL;
			}

			const sourcesArray = Array.isArray(sources) ? sources : [sources];
			_.each(sourcesArray, (source)=> {
				var sourceName = store ? store.get(source)[store.labelProperty] : null;
				Sourcing.createSupplierItems(m_writer, fd, creator, source, sourceName);
			});

			return call;
		}
	});
});